<script>
import Layout from "../../layouts/auth";
import appConfig from "@/app.config";

import { required, minLength } from "vuelidate/lib/validators";
import { userService } from '@/helpers/authservice/user.service';

export default {
  page: {
    title: "Activate Account",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
  },
  data() {
    return {
      email: this.$route.params.email,
      password: "",
      confirmedPassword: "",
      token: this.$route.params.token,
      submitted: false,
      isSamePassword: false,
    };
  },
  validations: {
    password: {
      required,
      minLength: minLength(6)
    },
  },
  methods: {
    tryToLogIn() {
        if(this.password == this.confirmedPassword) this.isSamePassword = true
        this.submitted = true;
        this.$v.$touch();
        
        if (this.$v.$invalid || !this.isSamePassword) {
            return;
        } else {
          userService.changePassword(this.password, this.email, this.token)
          this.$router.push({path:'/login'})
      }
    }
  },
};
</script>

<template>
    <Layout>
      <div class="row justify-content-center">
        <div class="activate-container">
          <br/><br/><br/>

          <div class="row">
            <div class="col-lg-12 center"> 
              <router-link tag="a" to="/">
                <img src="@/assets/images/logo.gif" alt height="60" />
              </router-link>
            </div>

            <div class="col-lg-12 center"> 
              <span><b class="green">Welly Go </b></span>
              <span><b class="orange">RESTÓ</b></span>
            </div>
          </div>

          <br/>

          <p class="center">Elegí tu contraseña para comenzar a utilizar tu cuenta </p>


          <b-form class="p-2" @submit.prevent="tryToLogIn">
            <b-form-group
              class="mb-3 green"
              id="input-group-1"
              label="Email"
              label-for="input-1"
            >
              <b-form-input
                disabled
                class="btn-outline"
                id="input-1"
                v-model="email"
                type="text"
              ></b-form-input>
            </b-form-group>

            <b-form-group
              class="mb-3 green"
              id="input-group-2"
              label="Contraseña"
              label-for="input-2"
            >
              <b-form-input
                class="btn-outline"
                id="input-2"
                v-model="password"
                type="password"
                placeholder="Ingrese contraseña"
                :class="{ 'is-invalid': submitted && $v.password.$error }"
              ></b-form-input>
              <div
                v-if="submitted && !$v.password.required"
                class="invalid-feedback"
              >
                Contraseña es requerida.
              </div>
              <div
                v-if="submitted && !$v.password.minLength"
                class="invalid-feedback"
              >
                La contraseña debe tener al menos 6 caracteres.
              </div>
            </b-form-group>

            <b-form-group
              class="mb-3 green"
              id="input-group-2"
              label="Confirmar contraseña"
              label-for="input-2"
            >
              <b-form-input
                class="btn-outline"
                id="input-2"
                v-model="confirmedPassword"
                type="password"
                placeholder="Ingrese nuevamente contraseña"
                :class="{ 'is-invalid': submitted && !isSamePassword }"
              ></b-form-input>
              <div
                v-if="submitted && !isSamePassword"
                class="invalid-feedback"
              >
                Las contraseñas deben ser iguales.
              </div>

            </b-form-group>

            <br/>
            <div class="center">
              <b-button type="submit" variant="success" class="btn-width"
                >Iniciar sesión</b-button
              >
            </div>
          </b-form>
          <br/><br/><br/><br/>
        </div>
      </div>
    </Layout>
  </template>
  
  <style lang="scss" scoped>
  @import "@/design/settings";
  @import '@/design/views/account/activate';
  </style>